export const badge = {
  fontSize: 1.2,
  lineHeight: 1.2,
  padding: '10px',
  fontWeight: '800',
  textTransform: 'uppercase'
};
